import { ApiState } from '@/store/types/general.types';
import { ResearchNode } from '@/store/modules/documents/types/documents.types';
import {
  PendingDocumentSettingsDto as PendingDocumentSettings,
  PendingProjectSettingsDto
} from '@/jbi-shared/types/full-document-revision-object.types';

// Frontend-specific state interface (adds ResearchNode objects vs IDs)
export interface PendingProjectSettings {
  projectTitle?: string;
  primaryResearchNode: ResearchNode | undefined;
  researchNodes: ResearchNode[];
}

export interface PendingDocumentsState {
  documentSettings: {
    [documentId: number]: PendingDocumentSettings;
  };
  projectSettings: {
    [documentId: number]: PendingProjectSettings;
  };
  apiState: {
    getDocumentSettings: ApiState;
    updateDocumentSettings: ApiState;
    getProjectSettings: ApiState;
    updateProjectSettings: ApiState;
  };
}

export const initialState: PendingDocumentsState = {
  documentSettings: {},
  projectSettings: {},
  apiState: {
    getDocumentSettings: {
      loading: false,
      success: false,
      error: null
    },
    updateDocumentSettings: {
      loading: false,
      success: false,
      error: null
    },
    getProjectSettings: {
      loading: false,
      success: false,
      error: null
    },
    updateProjectSettings: {
      loading: false,
      success: false,
      error: null
    }
  }
};
